import apiCall from "./apiCall";
import {METHOD_POST} from "../consts/networkConsts";

const apiPost = async (endpoint, body, params, controller) => {
  const response = await apiCall(
    METHOD_POST,
    endpoint,
    params,
    body,
    controller
  );
  return response;
}

export default apiPost;
